import React from "react";
import { Button, ButtonProps } from "@amzn/awsui-components-react";
import { Stage } from "../../lusca-search-api/generated-src";
import { investigationPath } from "./investigationUtils";

interface OpenInvestigationButtonProps {
  stage: Stage;
  investigationId?: string | null;
  /** Investigation title, used for the accessible name. Falls back to the ID. */
  title?: string | null;
  /** Visible label. Default "Open". */
  children?: React.ReactNode;
  variant?: ButtonProps.Variant;
  fullWidth?: boolean;
  /** Override the accessible name (default: "Open investigation <title> in a new tab"). */
  ariaLabel?: string;
}

/**
 * Link to an investigation's full page that always opens in a NEW tab, so whatever the user is
 * doing in the drawer or population builder (a draft, a row being triaged) is never lost.
 * Renders nothing without an investigation ID.
 */
export const OpenInvestigationButton: React.FC<
  OpenInvestigationButtonProps
> = ({
  stage,
  investigationId,
  title,
  children = "Open",
  variant = "inline-link",
  fullWidth,
  ariaLabel,
}) => {
  if (!investigationId) return null;
  return (
    <Button
      variant={variant}
      fullWidth={fullWidth}
      iconName="external"
      iconAlign="right"
      href={investigationPath(investigationId, stage)}
      target="_blank"
      ariaLabel={
        ariaLabel ??
        `Open investigation ${title || investigationId} in a new tab`
      }
    >
      {children}
    </Button>
  );
};

export default OpenInvestigationButton;
